import { Action } from 'redux';
import {
  DECREASE_DETAILS_LOADING,
  DECREASE_LOADING,
  DECREASE_UPLOAD_LOADING,
  INCREASE_DETAILS_LOADING,
  INCREASE_LOADING,
  INCREASE_UPLOAD_LOADING,
  INCREASE_LOAD_BALANCE,
  DECREASE_LOAD_BALANCE,
  INCREASE_EXTRACT_LOAD,
  DECREASE_EXTRACT_LOAD,
  DECREASE_CARD_LOAD,
  INCREASE_CARD_LOAD,
} from '~/actions/actionTypes';
import { LoadingReducer } from '~/models/reducers';

const initialState: reducers.LoadingReducer = {
  amount: 0,
  load: false,
  loadTransactionList: false,
  loadCard: false,
  loadBalance: false,
  loadUploadImages: false,
  detailsLoading: false,
};

let incLoadUploadImages = 0;
let incDetails = 0;
let incLoadBalance = 0;
let incLoadTransactionList = 0;
let incLoadCard = 0;

const loadingReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case INCREASE_LOADING:
      state = {
        ...state,
        amount: state.amount + 1,
      };
      break;

    case DECREASE_LOADING:
      if (state.amount > 0) {
        state = {
          ...state,
          amount: state.amount - 1,
        };
      }
      break;

    case INCREASE_LOAD_BALANCE:
      incLoadBalance += 1;
      state = {
        ...state,
        loadBalance: incLoadBalance > 0,
      };
      break;

    case DECREASE_LOAD_BALANCE:
      incLoadBalance -= 1;
      state = {
        ...state,
        loadBalance: incLoadBalance > 0,
      };
      break;

    case INCREASE_EXTRACT_LOAD:
      incLoadTransactionList += 1;
      state = {
        ...state,
        loadTransactionList: incLoadTransactionList > 0,
      };
      break;

    case DECREASE_EXTRACT_LOAD:
      incLoadTransactionList -= 1;
      state = {
        ...state,
        loadTransactionList: incLoadTransactionList > 0,
      };

      break;

    case INCREASE_CARD_LOAD:
      incLoadCard += 1;
      state = {
        ...state,
        loadCard: incLoadCard > 0,
      };
      break;

    case DECREASE_CARD_LOAD:
      incLoadCard -= 1;
      state = {
        ...state,
        loadCard: incLoadCard > 0,
      };

      break;

    case INCREASE_UPLOAD_LOADING:
      incLoadUploadImages += 1;
      state = {
        ...state,
        loadUploadImages: incLoadUploadImages > 0,
      };
      break;
    case DECREASE_UPLOAD_LOADING:
      incLoadUploadImages -= 1;
      state = {
        ...state,
        loadUploadImages: incLoadUploadImages > 0,
      };
      break;

    case INCREASE_DETAILS_LOADING:
      incDetails += 1;

      return {
        ...state,
        detailsLoading: incDetails > 0,
      };
    case DECREASE_DETAILS_LOADING:
      incDetails -= 1;

      return {
        ...state,
        detailsLoading: incDetails > 0,
      };
    default:
      return state;
  }

  return state;
};

export const isLoading = (state: LoadingReducer) => {
  return state.amount > 0;
};

export default loadingReducer;
